// Backs the "Available offline" toggle with a real local cache (the browser's
// Cache Storage API), so it isn't just a cosmetic server-side flag. Content
// URLs are pre-signed and expire, so they can't be used as a stable cache
// key — items are keyed by their own id instead.
const CACHE_NAME = 'skdrive-offline-v1';
const keyFor = (itemId: string) => `https://skdrive.offline/${itemId}`;

export async function cacheItemOffline(itemId: string, contentUrl: string): Promise<void> {
  const resp = await fetch(contentUrl);
  if (!resp.ok) throw new Error('Could not download file for offline use');
  const blob = await resp.blob();
  const cache = await caches.open(CACHE_NAME);
  await cache.put(keyFor(itemId), new Response(blob, { headers: { 'Content-Type': resp.headers.get('Content-Type') ?? 'application/octet-stream' } }));
}

export async function evictItemOffline(itemId: string): Promise<void> {
  const cache = await caches.open(CACHE_NAME);
  await cache.delete(keyFor(itemId));
}

export async function isCachedOffline(itemId: string): Promise<boolean> {
  const cache = await caches.open(CACHE_NAME);
  return !!(await cache.match(keyFor(itemId)));
}

/** Returns a blob: URL for the offline copy, or null if this item isn't cached. */
export async function getOfflineBlobUrl(itemId: string): Promise<string | null> {
  const cache = await caches.open(CACHE_NAME);
  const match = await cache.match(keyFor(itemId));
  if (!match) return null;
  const blob = await match.blob();
  return URL.createObjectURL(blob);
}
